import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Component6cards from '../components/component6cards'
import FooterMain from '../components/footer-main'
import './exhibition-robotic.css'

const ExhibitionRobotic = (props) => {
  return (
    <div className="exhibition-robotic-container">
      <Helmet>
        <title>
          Выставочные и интерактивные роботизированные комплексы | Arcobo
        </title>
        <meta
          name="description"
          content="Arcobo проектирует интерактивные роботизированные комплексы для выставок, шоурумов, музеев и мероприятий: робот-художник, робот-бариста, робот-повар, робот-шахматист и VR-инсталляции."
        />
        <meta
          property="og:title"
          content="Выставочные и интерактивные роботизированные комплексы | Arcobo"
        />
        <meta
          property="og:description"
          content="Arcobo проектирует интерактивные роботизированные комплексы для выставок, шоурумов, музеев и мероприятий: робот-художник, робот-бариста, робот-повар, робот-шахматист и VR-инсталляции."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Выставочные и интерактивные роботизированные комплексы | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Arcobo проектирует интерактивные роботизированные комплексы для выставок, шоурумов, музеев и мероприятий: робот-художник, робот-бариста, робот-повар, робот-шахматист и VR-инсталляции."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/exhibition-robotic"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/exhibition-robotic"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Выставочные и интерактивные комплексы","item":"https://arcobo.tech/exhibition-robotic"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name25"></HeaderMain>
      <hr className="exhibition-robotic-separator1"></hr>
      <Component6cards
        titleAs="h1"
        componentText="Проектируем интерактивные роботизированные комплексы для выставок, шоурумов, музеев, образовательных центров и корпоративных мероприятий."
        feature1Title="Робот-художник"
        feature2Title="Робот-бариста"
        feature3Title="Робот-повар"
        feature4Title="Робот-шахматист"
        feature5Title="Робот-гид по макету"
        feature6Title="VR-полёт"
        rootClassName="component6cardsroot-class-name"
        componentTitle="Выставочные и интерактивные комплексы"
        feature1ImageSrc="/1_Solution/1_4_1_Interactive/drawer-1500w.webp"
        feature1ImageAlt="Робот-рисовальщик"
        feature2ImageSrc="/1_Solution/1_4_1_Interactive/barista-300h.webp"
        feature2ImageAlt="Робот-бариста"
        feature3ImageSrc="/1_Solution/1_4_1_Interactive/cook-300h.webp"
        feature3ImageAlt="Робот-повар"
        feature4ImageSrc="/1_Solution/1_4_1_Interactive/chess-1500w.webp"
        feature4ImageAlt="Робот, играющий в шахматы"
        feature5ImageSrc="/1_Solution/1_4_1_Interactive/gid-300h.webp"
        feature5ImageAlt="Робот-гид"
        feature6ImageSrc="/1_Solution/1_4_1_Interactive/vr-300h.webp"
        feature6ImageAlt="VR-комплекс с роботом"
        feature1Description={
          <Fragment>
            <span className="exhibition-robotic-thq-feature1-description-elm1 thq-body-small">
              <span>
                Фотографирует посетителя → преобразует фотографию в
                художественный эскиз → рисует портрет тушью → вручает готовую
                работу.
              </span>
              <br></br>
              <br></br>
              <span className="exhibition-robotic-text13">✓</span>
              <span> Индивидуальный сувенир каждому гостю</span>
              <br></br>
              <span className="exhibition-robotic-text16">✓</span>
              <span> Высокая вовлеченность посетителей</span>
              <br></br>
              <span className="exhibition-robotic-text19">✓</span>
              <span> Контент для социальных сетей</span>
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="exhibition-robotic-thq-feature1-description-elm2 thq-body-small">
              <span>
                Гость выбирает напиток → оплата по QR → робот запускает
                кофемашину → робот подает готовый напиток посетителю.
              </span>
              <br></br>
              <br></br>
              <span className="exhibition-robotic-text24">✓</span>
              <span> Привлекает поток посетителей к стенду</span>
              <br></br>
              <span className="exhibition-robotic-text27">✓</span>
              <span> Демонстрирует возможности промышленной роботизации</span>
              <br></br>
              <span className="exhibition-robotic-text30">✓</span>
              <span> Повышает узнаваемость бренда</span>
              <span></span>
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="exhibition-robotic-text33">
              <span>
                Робот автоматически обжаривает баурсаки → аккуратно выкладывает
                их на блюдо → подает готовую порцию посетителю.
              </span>
              <br></br>
              <br></br>
              <span className="exhibition-robotic-text37">✓</span>
              <span> Национальная кухня в технологичном формате</span>
              <br></br>
              <span className="exhibition-robotic-text40">✓</span>
              <span> Яркое интерактивное шоу для гостей выставки</span>
              <br></br>
              <span className="exhibition-robotic-text43">✓</span>
              <span> Привлекает посетителей и создает запоминающийся опыт</span>
            </span>
          </Fragment>
        }
        feature4Description={
          <Fragment>
            <span className="exhibition-robotic-text45">
              <span>
                Посетитель выбирает уровень сложности → играет партию с роботом
                → при необходимости получает подсказки и разбор лучших ходов.
              </span>
              <br></br>
              <br></br>
              <span className="exhibition-robotic-text49">✓</span>
              <span>
                {' '}
                Несколько уровней сложности — от новичка до опытного игрока
              </span>
              <br></br>
              <span className="exhibition-robotic-text52">✓</span>
              <span> Интерактивные подсказки и обучение во время партии</span>
              <br></br>
              <span className="exhibition-robotic-text55">✓</span>
              <span>
                {' '}
                Одновременная игра до 3 партий на трех шахматных досках
              </span>
            </span>
          </Fragment>
        }
        feature5Description={
          <Fragment>
            <span className="exhibition-robotic-text57">
              <span>
                Робот подсвечивает лазером элементы макета → берет деталь в
                захват и показывает посетителям → выводит на экран цифровую
                модель или доп. информацию.
              </span>
              <br></br>
              <br></br>
              <span className="exhibition-robotic-text61">✓</span>
              <span>
                {' '}
                Акцентирует внимание на ключевых элементах экспозиции
              </span>
              <br></br>
              <span className="exhibition-robotic-text64">✓</span>
              <span>
                {' '}
                Наглядно демонстрирует устройство изделий и процессов
              </span>
              <br></br>
              <span className="exhibition-robotic-text67">✓</span>
              <span>
                {' '}
                Создает современную интерактивную презентацию для выставок и
                шоурумов
              </span>
            </span>
          </Fragment>
        }
        feature6Description={
          <Fragment>
            <span className="exhibition-robotic-text69">
              <span>
                Промышленный робот превращается в динамическую VR-платформу,
                воспроизводя движения, ускорения и наклоны синхронно с
                виртуальным миром.
              </span>
              <br></br>
              <br></br>
              <span className="exhibition-robotic-text73">✓</span>
              <span>
                {' '}
                Реалистичная имитация полета и других динамических сценариев
              </span>
              <br></br>
              <span className="exhibition-robotic-text76">✓</span>
              <span>
                {' '}
                Возможность быстро менять VR-контент под тематику мероприятия
              </span>
              <br></br>
              <span className="exhibition-robotic-text79">✓</span>
              <span>
                {' '}
                Запоминающийся интерактивный аттракцион для выставок и шоурумов
              </span>
            </span>
          </Fragment>
        }
      ></Component6cards>
      <hr className="exhibition-robotic-separator2"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name24"></FooterMain>
    </div>
  )
}

export default ExhibitionRobotic
